import { shouldShowActionRecommendation } from 'automation-ui-canvas/components/canvas/next-action-recommender/utils/shouldShowActionRecommendation';
import { GET_NEXT_ACTION_RECOMMENDATION } from 'automation-ui-canvas/components/canvas/next-action-recommender/queries/getNextActionRecommendation';
import { actionRecommendationSupportedObjectTypeIds } from 'automation-ui-canvas/components/canvas/next-action-recommender/constants/actionRecommendationSupportedObjectTypeIds';
import { useQuery } from 'data-fetching-client';
export const useNextActionRecommender = ({
  ancestorActionTypeIds,
  flowObjectTypeId,
  disableRecommendationOverride
}) => {
  var _ancestorActionTypeId, _data$getNextActionRe, _data$getNextActionRe2, _data$getNextActionRe3;
  const skip = disableRecommendationOverride || !flowObjectTypeId || !actionRecommendationSupportedObjectTypeIds[flowObjectTypeId] || !ancestorActionTypeIds || !shouldShowActionRecommendation(ancestorActionTypeIds !== null && ancestorActionTypeIds !== void 0 ? ancestorActionTypeIds : [], flowObjectTypeId);
  const lastFourActionTypeIds = (_ancestorActionTypeId = ancestorActionTypeIds === null || ancestorActionTypeIds === void 0 ? void 0 : ancestorActionTypeIds.slice(-4)) !== null && _ancestorActionTypeId !== void 0 ? _ancestorActionTypeId : [];
  const {
    data,
    loading,
    error
  } = useQuery(GET_NEXT_ACTION_RECOMMENDATION, {
    variables: {
      actionTypeId1: lastFourActionTypeIds[0],
      actionTypeId2: lastFourActionTypeIds[1],
      actionTypeId3: lastFourActionTypeIds[2],
      actionTypeId4: lastFourActionTypeIds[3],
      flowObjectType: actionRecommendationSupportedObjectTypeIds[flowObjectTypeId]
    },
    skip
  });
  return {
    chirpAiContextObject: data === null || data === void 0 || (_data$getNextActionRe = data.getNextActionRecommendation) === null || _data$getNextActionRe === void 0 ? void 0 : _data$getNextActionRe.chirpAiContextObject,
    actionTypeIdInnerIdsToScores: (_data$getNextActionRe2 = data === null || data === void 0 || (_data$getNextActionRe3 = data.getNextActionRecommendation) === null || _data$getNextActionRe3 === void 0 ? void 0 : _data$getNextActionRe3.actionTypeIdInnerIdsToScores) !== null && _data$getNextActionRe2 !== void 0 ? _data$getNextActionRe2 : {},
    loading,
    error,
    shouldShowActionRecommendation: !loading && !error && !skip
  };
};